import { FC } from "react"
import { TravelersEdit } from "../../../module/travelers/containers/edit"

export const TravelersEditPage: FC = () => <TravelersEdit />
